import { SxProps, Theme } from '@mui/system';

const classes = {
  shiftTypeContainer: {
    // mb: '12px',
    display: 'flex',
    flexDirection: 'column',
  },
  shiftLabelContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  shiftText: {
    fontSize: '16px',
    fontWeight: '600',
    ml: '6px',
  },
  singleShiftText: {
    color: 'chartColors.green170',
  },
  multipleShiftText: {
    color: 'chartColors.blue237',
  },
  rangeLabelContainer: {
    backgroundColor: 'common.newBlue',
    alignSelf: 'flex-start',
    paddingX: '10px',
    borderRadius: '50px',
    my: '8px',
    paddingY: '2px',
  },
  rangeLabel: {
    color: 'secondary.main',
    fontSize: '13px',
  },
  shiftIdentifierContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    mb: '16px',
  },
} satisfies Record<string, SxProps<Theme>>;

export default classes;
